export default class Onboarding {
  constructor(box21_api) {
    this.api = box21_api;
  }

  async getStatus() {
    const formData = new FormData();
    formData.append('project_id', sessionStorage.getItem('project_id'));
    return this.api.post_with_token('/onboarding/status', formData);
  }

  async bootstrapTrainConfig() {
    const formData = new FormData();
    formData.append('project_id', sessionStorage.getItem('project_id'));
    return this.api.post_with_token('/onboarding/bootstrap-train-config', formData);
  }
}
